export default "__VITE_ASSET__07a0d409__"